var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('base-material-card',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('v-row',{staticClass:"d-s-flex"},[_c('v-col',{class:_vm.$vuetify.breakpoint.smAndDown
							? 'text-center display-2 font-weight-light'
							: 'display-2 font-weight-light',attrs:{"cols":"12"}},[_vm._v(" לידים ")])],1)]},proxy:true}])},[_c('tracks-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }